import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../guard/auth.guard';

const routes: Routes = [
    { path: 'main/devices/:id',      loadChildren: () => import('./devices/devices.module').then(m => m.DevicesPageModule),
        canActivate: [AuthGuard] },
    { path: 'main/devices/camera/:id',  loadChildren: () => import('./devices/camera/camera.module').then(m => m.CameraPageModule),
        canActivate: [AuthGuard] },
    { path: 'main/devices/device/:id',  loadChildren: () => import('./devices/device/device.module').then(m => m.DevicePageModule),
        canActivate: [AuthGuard] },
    { path: 'main/schedules',    loadChildren: () => import('./schedules/schedules.module').then(m => m.SchedulesPageModule),
        canActivate: [AuthGuard] },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MainRoutingModule {
}
